import axios from 'axios'
import io from "socket.io-client";
import { toast } from "react-toastify";
import addNotification from "react-push-notification";
import { 
  LISTEN_TICKETS_START,
  FETCH_TICKETS,
  UPDATE_ACTIVE_TICKET,
  CALL_TICKET,
  COMPLETE_TICKET,
  TRANSFER_TICKET,
  REISSUE_TICKET,
  NO_SHOW_TICKET,
  LISTEN_CALL_TICKETS_START,
  LISTEN_TRANSFER_TICKETS_START,
  FETCH_CALL_TICKETS,
  FETCH_TRANSFER_TICKETS,
  INCREASE_LISTEN_TICKET_COUNT,
  SAVE_LATEST_TICKET,
  UPDATE_ACTIVE_MANAGEMENT_TICKET,
  UPDATE_FETCHED_TICKETS_STATUS,
} from './types';
import store from '../../store';
import { getManagementLockFromTicket, isSupervisorUser } from '../helpers';

import { getAPI, getQmaBaseUrl } from '../helpers';

const api = getAPI();
const { REACT_APP_IS_DEV  } = process.env;

let socket = {}; // Declare a variable to hold the Socket.IO client instance
const notifiedSlaBreachIds = new Set();

const SLA_BREACH_LISTEN_TYPES = [
  'LISTEN_SLA_BREACHES_CREATE',
  'LISTEN_SLA_BREACHES_UPDATE',
];

const TICKET_LISTEN_TYPES = [
  'LISTEN_TICKETS_CREATE',
  'LISTEN_TICKETS_UPDATE',
];

export const getActiveServiceBreach = (ticket) => {
  const breach = ticket && (ticket.slaBreach || ticket);
  if (
    Number(ticket && ticket.status) === 1
    && ticket.slaBreached
    && breach
    && breach.breachType === 'active-service-time'
    && breach.ticketId
  ) {
    return breach;
  }

  if (
    breach
    && breach.breachType === 'active-service-time'
    && breach.ticketId
  ) {
    return breach;
  }

  return null;
};

const notifySlaBreach = (breach) => {
  if (!breach || !breach.ticketId || notifiedSlaBreachIds.has(breach.ticketId)) {
    return;
  }

  notifiedSlaBreachIds.add(breach.ticketId);
  const ticketLabel = `${breach.ticketLetter || ''}${breach.ticketNumber || ''}`;
  const activeMinutes = breach.activeServiceMinutes || Math.ceil((Number(breach.activeServiceSeconds) || 0) / 60);
  const thresholdMinutes = breach.thresholdMinutes || Math.ceil((Number(breach.thresholdSeconds) || 0) / 60);
  const message = `Ticket ${ticketLabel} has been active for ${activeMinutes} minutes. SLA limit: ${thresholdMinutes} minutes.`;

  toast.warning(
    `Service SLA breached: ${message}`,
    { toastId: `sla-breach-${breach.ticketId}` }
  );

  addNotification({
    title: 'Service SLA breached',
    message,
    onClick: '/queuing/supervisor/',
    native: true
  });
};

export const getSlaBreachNotificationPayload = ({
  type,
  payload,
  oldVal = null,
  authenticatedUser = null,
}) => {
  const isSlaBreachEvent = SLA_BREACH_LISTEN_TYPES.includes(type);
  const isTicketEvent = TICKET_LISTEN_TYPES.includes(type);

  if (!isSlaBreachEvent && !isTicketEvent) {
    return null;
  }

  if (!isSupervisorUser(authenticatedUser)) {
    return null;
  }

  const breach = getActiveServiceBreach(payload);

  if (!breach) {
    return null;
  }

  if (isSlaBreachEvent) {
    return breach;
  }

  const oldBreach = getActiveServiceBreach(oldVal);
  return oldBreach && oldBreach.ticketId === breach.ticketId ? null : breach;
};

export const maybeNotifySlaBreach = ({ type, payload, oldVal = null }) => {
  const { authenticatedUser } = store.getState().auth;
  const breach = getSlaBreachNotificationPayload({
    type,
    payload,
    oldVal,
    authenticatedUser,
  });

  notifySlaBreach(breach);
};

const listenToEvent = (hostname, eventName, updateType) => (dispatch) => {
  const baseURL = Number(REACT_APP_IS_DEV) ? api : getQmaBaseUrl(hostname);
  socket[eventName] = io(baseURL);
  const startType = updateType + '_START';
  dispatch({ type: startType, payload: 1 });
  socket[eventName].on(`${eventName}-updated`, (res) => {
    let type, payload;
    if (res.new_val != null) {
      type = updateType + (res.old_val != null ? '_UPDATE' : '_CREATE');
      payload = res.new_val;
    } else {
      type = updateType + '_DELETE';
      payload = res.old_val;
    }
    dispatch({ type, payload })

    if(type === 'LISTEN_TICKETS_CREATE' && !payload.reissued){
      dispatch({
        type: INCREASE_LISTEN_TICKET_COUNT,
        payload: res.new_val
      })
      dispatch({
        type: SAVE_LATEST_TICKET,
        payload: res.new_val
      })
    }

    maybeNotifySlaBreach({ type, payload, oldVal: res.old_val });

    // management layout controls
    if(type === 'LISTEN_CALL_TICKETS_CREATE'){
      if(payload.tracking != null){
        dispatch(updateTicket(hostname, { id: payload.ticketId, tracking: { ...payload.tracking, packageStatus: "Parcel is being processed" } }));
      }
    }
  });
};

const listenToEventStop = (eventName, updateType) => (dispatch) => {
  if (socket[eventName]) {
    socket[eventName].off(`${eventName}-updated`);
    socket[eventName].disconnect();
    socket[eventName] = null;
  }
  const type = updateType + '_START';
  dispatch({ type, payload: 0 });
}

// Events
export const listenTickets = (hostname) =>
  listenToEvent(hostname, 'management_tickets', 'LISTEN_TICKETS');
export const listenTicketsStop = () =>
listenToEventStop('management_tickets', 'LISTEN_TICKETS');

export const listenSlaBreaches = (hostname) =>
  listenToEvent(hostname, 'management_tickets_sla_breaches', 'LISTEN_SLA_BREACHES');
export const listenSlaBreachesStop = () =>
listenToEventStop('management_tickets_sla_breaches', 'LISTEN_SLA_BREACHES');

export const listenCallTickets = (hostname) =>
  listenToEvent(hostname, 'management_callTickets', 'LISTEN_CALL_TICKETS');
export const listenCallTicketsStop = () =>
listenToEventStop('management_callTickets', 'LISTEN_CALL_TICKETS');

export const listenTransferTickets = (hostname) =>
  listenToEvent(hostname, 'management_transferTickets', 'LISTEN_TRANSFER_TICKETS');
export const listenTransferTicketsStop = () =>
listenToEventStop('management_transferTickets', 'LISTEN_TRANSFER_TICKETS');

export const fetchTickets = (hostname) => dispatch => {
  const baseURL = Number(REACT_APP_IS_DEV) ? api : getQmaBaseUrl(hostname);
  const auth = store.getState().auth
  const { authenticatedUser } = auth
  const { accessToken } = authenticatedUser
  
  axios.get( 
    baseURL + '/management/tickets/',
    {
      headers: {
        'Authorization': `Basic ${accessToken}`
      }
    } 
  )
  .then(res =>
    dispatch({
      type: FETCH_TICKETS,
      payload: res.data
    })
  )
  .catch(err => console.log(err) )
};
export const updateListenTicketsStart = (payload) => dispatch => {
  dispatch({
    type: LISTEN_TICKETS_START,
    payload
  })
};
export const callTicket = (hostname, payload) => dispatch => {
  const baseURL = Number(REACT_APP_IS_DEV) ? api : getQmaBaseUrl(hostname);
  return axios.post( baseURL + '/localrmq/', payload )
  .then(res =>
    dispatch({
      type: CALL_TICKET,
      payload: res.data
    })
  )
  .catch(err => console.log(err) )
};

export const updateActiveTicket = payload => dispatch => {
  dispatch({
    type: UPDATE_ACTIVE_TICKET,
    payload
  })
};

// ticket actions
export const completeTicket = (hostname, payload) => dispatch => {
  const baseURL = Number(REACT_APP_IS_DEV) ? api : getQmaBaseUrl(hostname);
  axios.post( baseURL + '/localrmq/', payload)
  .then(res => {
    if (!payload.msg.supervisorOverride) {
      dispatch( updateActiveTicket({id: null}) )
    }
    dispatch({
      type: COMPLETE_TICKET,
      payload: res.data
    })
  })
  .catch(err => console.log(err) )
};

export const noShowTicket = (hostname, payload) => dispatch => {
  const baseURL = Number(REACT_APP_IS_DEV) ? api : getQmaBaseUrl(hostname);
  axios.post( baseURL + '/localrmq/', payload)
  .then(res => {
    if (!payload.msg.supervisorOverride) {
      dispatch( updateActiveTicket({id: null}) )
    }
    dispatch({
      type: NO_SHOW_TICKET,
      payload: res.data
    })
  })
  .catch(err => console.log(err) )
};

export const transferTicket = (hostname, payload) => dispatch => {
  const baseURL = Number(REACT_APP_IS_DEV) ? api : getQmaBaseUrl(hostname);
  axios.post( baseURL + '/localrmq/', payload )
  .then(res => {
    const { ticketLetter, ticketNumber } = payload.msg.ticket
    toast.success('Ticket: ' + ticketLetter + '-' + ticketNumber + ', has been successfully transferred' );
    if (!payload.msg.supervisorOverride) {
      dispatch( updateActiveTicket({id: null}) )
    }
    dispatch({
      type: TRANSFER_TICKET,
      payload: res.data
    })
  })
  .catch(err => console.log(err) )
};

export const reissueTicket = (hostname, payload) => dispatch => {
  const baseURL = Number(REACT_APP_IS_DEV) ? api : getQmaBaseUrl(hostname);
  return axios.post( baseURL + '/localrmq/', payload )
  .then(res => {
    const { ticketLetter, ticketNumber } = payload.msg.oldTicket
    toast.success('Ticket: ' + ticketLetter + '-' + ticketNumber + ', has been successfully re-assigned' );
    dispatch( updateActiveTicket({id: null}) )
    dispatch({
      type: REISSUE_TICKET,
      payload: res.data
    })
    return res.data
  })
  .catch(err => console.log(err) )
};

export const updateListenCallTicketsSyncStart = (payload) => dispatch => {
  dispatch({
    type: LISTEN_CALL_TICKETS_START,
    payload
  })
};

export const fetchCallTickets = (hostname) => dispatch => {
  const baseURL = Number(REACT_APP_IS_DEV) ? api : getQmaBaseUrl(hostname);
  axios.get( baseURL + '/management/callTickets/' )
  .then(res =>
    dispatch({
      type: FETCH_CALL_TICKETS,
      payload: res.data
    })
  )
  .catch(err => console.log(err) )
};

export const updateListenTransferTicketsSyncStart = (payload) => dispatch => {
  dispatch({
    type: LISTEN_TRANSFER_TICKETS_START,
    payload
  })
};

export const fetchTransferTickets = (hostname) => dispatch => {
  const baseURL = Number(REACT_APP_IS_DEV) ? api : getQmaBaseUrl(hostname);
  axios.get( baseURL + '/management/transferTickets/' )
  .then(res =>
    dispatch({
      type: FETCH_TRANSFER_TICKETS,
      payload: res.data
    })
  )
  .catch(err => console.log(err) )
};

export const resetLatestTicket = () => dispatch => {
  dispatch({
    type: SAVE_LATEST_TICKET,
    payload: null
  })
};

export const updateActiveManagementTicketId = (payload) => dispatch => {
  dispatch({
    type: UPDATE_ACTIVE_MANAGEMENT_TICKET,
    payload
  })
};

export const updateManagementLock = (ticket) => dispatch => {
  const payload = getManagementLockFromTicket(ticket);
  dispatch({
    type: 'UPDATE_MANAGEMENT_LOCK',
    payload
  })
};

export const resetManagementLock = () => dispatch => {
  dispatch({
    type: 'UPDATE_MANAGEMENT_LOCK',
    payload: ""
  })
};
  
export const updateTicketsFetchedStatus = (payload) => dispatch => {
  dispatch({
    type: UPDATE_FETCHED_TICKETS_STATUS,
    payload
  })
};

export const updateTicket = (hostname, ticket) => dispatch => {
  const baseURL = Number(REACT_APP_IS_DEV) ? api : getQmaBaseUrl(hostname);
  axios.patch(baseURL + '/management/tickets/', ticket)
    .then(res => {
      
    });
};
